import React from 'react';
import './CollectionPointsPopup.scss';
import LocationIcon from '../Icons/location.svg';
import SuccessIcon from '../Icons/success.svg';
import WazeIcon from '../Icons/waze.png';
import CloseIcon from '../Icons/x.png';
import Image from 'app/Components/Shared/Image/image';

// הגדרות סוגי הפופאפ
const POPUP_TYPES = {
  SELECT_POINT: {
    icon: LocationIcon,
    description: 'כדי לקבל את ספק הכוח יש להציג\n את האישור שיישלח לך ב SMS\nהאישור תקף לכל נקודות האיסוף',
    primaryButtonText: 'שלחו לי אישור איסוף',
    showWaze: false,
  },
  CONFIRM_SMS: {
    icon: SuccessIcon,
    description: 'בנקודת האיסוף שבחרת או בכל נקודה \n אחרת מהרשימה',
    secondaryButtonText: 'סיום',
    showWaze: true,
    wazeText: 'ניווט לנקודת האיסוף',
  },
};

const CollectionPointsPopup = ({
  isOpen,
  onClose,
  type = 'SELECT_POINT', // 'SELECT_POINT' | 'CONFIRM_SMS'
  title,
  phoneNumber,
  onPrimaryClick,
  onSecondaryClick,
  onWazeClick,
}) => {
  if (!isOpen) return null;

  const PopUpData = POPUP_TYPES[type] || POPUP_TYPES.SELECT_POINT;

  // בניית הכותרת לפי סוג
  const getTitle = () => {
    if (title) return title;
    if (type === 'CONFIRM_SMS') {
      return `ברגעים אלו נשלח אליך\nאישור בהודעת SMS\nלמספר ${phoneNumber || ''}`;
    }
    return '';
  };

  return (
    <div className='CollectionPointsPopup'>
      <div className='popup-overlay' onClick={onClose}>
        <div className={`popup-content ${type === 'CONFIRM_SMS' ? 'confirm-popup' : ''}`} onClick={(e) => e.stopPropagation()}>
          <button className='popup-close' onClick={onClose}>
            <Image src={CloseIcon} alt='close' />
          </button>

          <div className='popup-icon'>
            <Image src={PopUpData.icon} alt='icon' />
          </div>

          <h2 className='popup-title'>{getTitle()}</h2>

          {PopUpData.description && (
            <p className='popup-description'>{PopUpData.description}</p>
          )}

          {PopUpData.showWaze && (
            <button className='popup-link' onClick={onWazeClick}>
              <Image src={WazeIcon} alt='waze' className='waze-icon' />
              {PopUpData.wazeText}
            </button>
          )}

          {PopUpData.primaryButtonText && (
            <button className='popup-button primary' onClick={onPrimaryClick}>
              {PopUpData.primaryButtonText}
            </button>
          )}

          {PopUpData.secondaryButtonText && (
            <button className='popup-button secondary' onClick={onSecondaryClick}>
              {PopUpData.secondaryButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CollectionPointsPopup;
